import { axiosInstance } from "./globals";
import * as userService from "./userService";

export async function getLatestActivePrivacyPolicy() {
  return (await axiosInstance.get("/PrivacyPolicy/latestActive", { headers: userService.getAuthHeaders() })).data;
}

export async function getActivePolicyConsentStatus() {
  return (await axiosInstance.get("/UserConsent/GetActivePolicyConsentStatus", { headers: userService.getAuthHeaders() })).data;
}

export async function saveActivePolicyConsent(data: { clientAddress: string, consentSource: string }) {
  return (await axiosInstance.post("/UserConsent/SaveActivePolicyConsent", data, { headers: userService.getAuthHeaders() })).data;
}

export async function create(data: any) {
  return (await axiosInstance.post("/PrivacyPolicy/create", data, { headers: userService.getAuthHeaders() })).data;
}

export async function update(data: any) {
  return (await axiosInstance.post("/PrivacyPolicy/update", data, { headers: userService.getAuthHeaders() })).data;
}

export async function deletePolicy(data: { id: number }) {
  return (await axiosInstance.post("/PrivacyPolicy/delete", data, { headers: userService.getAuthHeaders() })).data;
}

export async function getAll(data: any = {}) {
  return (await axiosInstance.post("/PrivacyPolicy/GetAll", data, { headers: userService.getAuthHeaders() })).data;
}

export async function getById(id: number | string) {
  return (await axiosInstance.get(`/PrivacyPolicy/GetById/${id}`, { headers: userService.getAuthHeaders() })).data;
}

export async function withdrawConsentAndDeleteAccount() {
  return (await axiosInstance.post("/UserConsent/WithdrawConsentAndDeleteAccount", {}, { headers: userService.getAuthHeaders() })).data;
}

export async function requestPersonalDataDeletion() {
  return (await axiosInstance.post("/Users/RequestPersonalDataDeletion", {}, { headers: userService.getAuthHeaders() })).data;
}
